import { useState } from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from '@/view/components/ui/use-toast'
import { usersService } from '@/app/services/usersService'
import { useAuth } from '@/app/hooks/useAuth'
import { useForm } from 'react-hook-form'

export const useSupervisorsCardController = (_id: string | null) => {
  const { user } = useAuth()
  const queryClient = useQueryClient()
  const formMethods = useForm()

  const isSupervisorNull = !_id

  const [newCommission, setNewCommission] = useState<number | string>('')

  const { mutateAsync } = useMutation({
    mutationFn: async ({
      data,
      id,
    }: {
      data: { commission: number }
      id: string
    }) => {
      return usersService.userUpdate(data, id)
    },
  })

  const handleCommissionChange = async () => {
    if (_id && newCommission) {
      try {
        const response = await mutateAsync({
          data: { commission: Number(newCommission) },
          id: _id,
        })

        if (response) {
          toast({
            title: 'Comissão atualizada com sucesso!',
          })

          queryClient.invalidateQueries({ queryKey: ['usersByRole'] })
        }
      } catch (error) {
        console.log(error)
        toast({
          variant: 'destructive',
          title:
            'Ocorreu um erro ao tentar atualizar a comissão, tente novamente mais tarde.',
        })
      }
    }
  }

  return {
    user,
    formMethods,
    isSupervisorNull,
    newCommission,
    setNewCommission,
    handleCommissionChange,
  }
}
